import React, { createContext, useEffect, useState } from 'react'

type CartData = {
	cartId: string
	timestamp: number
}

export type CartContextType = {
	cartId: string | null
	checkoutUrl: string | null
	setCart: (cartId: string, checkoutUrl: string) => void
	clearCart: () => void
}

export const CartContext = createContext<CartContextType | undefined>(undefined)

export const SessionStorageProvider: React.FC<{
	children: React.ReactNode
}> = ({ children }) => {
	const [cartId, setCartId] = useState<CartData | null>(null)
	const [checkoutUrl, setCheckoutUrl] = useState<string | null>(null)

	useEffect(() => {
		const cartData = localStorage.getItem('shopifyCartId')
		const storedCheckoutUrl = localStorage.getItem('shopifyCheckoutUrl')

		if (cartData) {
			const currentTime = Date.now()
			const expirationTime = 12 * 60 * 60 * 1000

			const { cartId, timestamp } = JSON.parse(cartData) as CartData

			if (currentTime - timestamp < expirationTime) {
				setCartId({ cartId, timestamp })
			} else {
				localStorage.removeItem('shopifyCartId')
			}
		}
		if (storedCheckoutUrl) setCheckoutUrl(storedCheckoutUrl)
	}, [])

	const setCart = (newCartId: string, newCheckoutUrl: string) => {
		const timestamp = Date.now()
		const cartData = {
			cartId: newCartId,
			timestamp,
		}
		setCartId(cartData)
		setCheckoutUrl(newCheckoutUrl)

		localStorage.setItem('shopifyCartId', JSON.stringify(cartData))
		localStorage.setItem('shopifyCheckoutUrl', newCheckoutUrl)
	}

	const clearCart = () => {
		setCartId(null)
		setCheckoutUrl(null)

		localStorage.removeItem('shopifyCartId')
		localStorage.removeItem('shopifyCheckoutUrl')
	}

	const localCartId = cartId?.cartId || null

	const value = { cartId: localCartId, checkoutUrl, setCart, clearCart }

	return <CartContext.Provider value={value}>{children}</CartContext.Provider>
}
